import { atom, useAtom } from "jotai"

type Config = {
  selected: string | null
}

const configAtom = atom<Config>({
  selected: null,
})

/**
 * Hook for managing selected conversation
 * Replaces the old useMail hook with clearer naming
 */
export function useSelectedConversation() {
  return useAtom(configAtom)
}
